import {apiEnvironment} from '../smoothr-web-app-core/environments/apiEnvironment';

export const table_dotCustomerGroup = 'table_dot';
export const customerGroup = table_dotCustomerGroup;

const supportEmail = {
	table_dot: 'olearys@smoothr.de'
};
const firebaseConfig = {
	table_dot: {
		apiKey: 'AIzaSyCmkJ5LhAwNaEyikSocOwcKi8aQ1kNBweE',
		authDomain: 'tabledot-4f377.firebaseapp.com',
		projectId: 'tabledot-4f377',
		storageBucket: 'tabledot-4f377.appspot.com',
		messagingSenderId: '702268553377',
		appId: '1:702268553377:web:4a4e8b5defbc317690d8e0',
		measurementId: 'G-N1SHXHQ63R',
		vapidKey: 'BEF2F2yB8F3F0hy9ESx2_4FZrr5i8DEE8kdC7iBTCr8BnMU1RXunnVTRqok9x6nuwhgKbNBO3nHsG4z_8kmmfY4'
	}
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyB1zuV-fVlLlytAWtsVdSapFLRkuETwcyg',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment,
	countryList: ['de'],
	hasRecommendations: false,
	venueId: '661645790bdef9ce8560a8ff',
	showOrderPriceFromBackend: false,
	showDiffrenceModal: false,
	payPalValidatePrice: true,
	payPalMinPrice: 8,
	getPriceByUser: false
};
